<template>
  <div>
    <label :class="['flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed py-9 px-4 transition', disabled ? 'border-slate-100 opacity-50 cursor-not-allowed' : hasFiles ? 'border-brand/50 bg-brand/5 cursor-pointer' : 'border-slate-200 hover:border-brand/40 hover:bg-slate-50 cursor-pointer']">
      <span class="text-3xl">{{ hasFiles ? '📎' : '📤' }}</span>
      <span :class="['text-sm text-center break-all', hasFiles ? 'text-slate-700 font-medium' : 'text-slate-500']">{{ fileLabel }}</span>
      <span v-if="!hasFiles" class="text-xs text-slate-400">{{ multiple ? 'Birden fazla dosya seçebilirsin' : 'Dosyayı seçmek için dokun' }}</span>
      <input type="file" :accept="accept" :disabled="disabled" :multiple="multiple" class="hidden" @change="onFile" />
    </label>
    <button :disabled="busy || disabled || !hasFiles" @click="submit" class="mt-4 w-full rounded-xl bg-brand hover:bg-brand-dark disabled:opacity-40 text-white font-semibold py-3.5 transition shadow-sm shadow-brand/30">
      {{ busy ? "Yükleniyor…" : "Gönder" }}
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class FileUpload extends Vue {
  @Prop({ default: "Dosya seç" }) label!: string;
  @Prop({ default: "image/*" }) accept!: string;
  @Prop({ type: Boolean, default: false }) busy!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) multiple!: boolean;

  files: File[] = [];

  get hasFiles(): boolean {
    return this.files.length > 0;
  }

  get fileLabel(): string {
    if (!this.hasFiles) return this.label;
    if (this.files.length === 1) return this.files[0].name;
    return `${this.files.length} dosya seçildi`;
  }

  onFile(e: any) {
    this.files = Array.from(e.target.files || []);
  }

  submit() {
    if (!this.hasFiles) return;
    this.$emit("submit", this.multiple ? this.files : this.files[0]);
  }
}
</script>
